import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.inviteNewCandidateValidaton = function () {
    const dictonary = {
      custom: {
        name: {
          required: () => t.t(dictEnum.LBL_Name) + t.t(dictEnum.WARN_IsRequired)
        },
        JobAdCode: {
          required: () => t.t(dictEnum.LBL_JobAdCode) + t.t(dictEnum.WARN_IsRequired)
        },
        mobile: {
          required: () => t.t(dictEnum.LBL_Mobile) + t.t(dictEnum.WARN_IsRequired)
        },
        dob: {
          required: () => t.t(dictEnum.LBL_DateofBirth) + t.t(dictEnum.WARN_IsRequired)
        },
        email: {
          required: () => t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090200-InviteNewCandidate/S090200-InviteNewCandidateValidaton.js